module.exports = __webpack_public_path__ + "static/dog-ef001bbeadd73f5dcc6c5136ae80a4be.png";